import { Component, inject, OnInit } from '@angular/core';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { ModalService } from '../../../../services/modal.service';
import { TodaysActivityStore } from '../../../../stores/today-activities.store';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { CardHeaderComponent } from '../../../atoms/card-header/card-header.component';
import { CardComponent } from '../../../atoms/card/card/card.component';
import { NoEntriesPlaceholderComponent } from '../../../molecules/no-entries-placeholder/no-entries-placeholder.component';
import { Activity } from '../../../organisms/activities/activities.types';
import { MainLayoutComponent } from '../../../organisms/main-layout/main-layout.component';
import { ModalScanQrCodeComponent } from '../../../organisms/modal/modal-scan-qr-code/modal-scan-qr-code.component';
import { CheckInItemComponent } from './check-in-item/check-in-item.component';

@Component({
  selector: 'app-check-in',
  templateUrl: './check-in.component.html',
  imports: [
    MainLayoutComponent,
    CardComponent,
    CardHeaderComponent,
    NoEntriesPlaceholderComponent,
    CheckInItemComponent,
    ButtonComponent,
  ],
})
export class CheckInComponent implements OnInit {
  protected readonly RequestStateEnum = RequestStateEnum;

  private modalService = inject(ModalService);
  private todaysActivityStore = inject(TodaysActivityStore);

  public activities = this.todaysActivityStore.entities;
  public requestState = this.todaysActivityStore.requestState;

  ngOnInit(): void {
    this.todaysActivityStore.load();
  }

  public async openModal(item: Activity): Promise<void> {
    this.modalService.openOverlayWithConfig(ModalScanQrCodeComponent, { activity: item });
  }
}
